import { SVGProps } from 'react'

function HidePassword(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      height={18}
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.31836 16.5L18.9434 1.5"
        stroke="#232B43"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.46973 14.8758C9.28874 15.1302 10.1422 15.2564 10.9997 15.25C14.4164 15.3075 17.8814 12.9058 20.0197 10.5525C20.4946 10.0253 20.4946 9.22466 20.0197 8.69749C19.2451 7.84767 18.3869 7.07796 17.4581 6.39999"
        stroke="#232B43"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0104 4.235C12.3529 4.07137 11.6772 3.9924 10.9996 4C7.64044 3.94417 4.16628 6.29333 1.98211 8.69583C1.50726 9.223 1.50726 10.0237 1.98211 10.5508C2.64622 11.2778 3.37106 11.9469 4.14878 12.5508"
        stroke="#22242A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 9.625C7.87478 8.79613 8.20395 8.00115 8.79005 7.41505C9.37615 6.82895 10.1711 6.49978 11 6.5"
        stroke="#22242A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.125 9.62416V9.62416C14.1252 10.4531 13.7961 11.2482 13.21 11.8344C12.6239 12.4206 11.8289 12.75 11 12.75"
        stroke="#22242A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

HidePassword.defaultProps = { role: 'graphics-document' }

export default HidePassword
